import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import AdRevenueQuery from '../components/AdRevenueQuery.vue'
import SystemConfigManagement from '../components/SystemConfigManagement.vue'
import AppInfoManagement from '../components/AppInfoManagement.vue'
import DataDashboard from '../components/DataDashboard.vue'
import UserManagement from '../components/UserManagement.vue'  // 用户管理组件导入
import UserWithdrawalManagement from '../components/UserWithdrawalManagement.vue'  // 用户提现管理组件导入
import RiskManagement from '../components/RiskManagement.vue'  // 风控管理
import CoinFlowManagement from '../components/CoinFlowManagement.vue'  // 金币明细
import AdPoolSettlementManagement from '../components/AdPoolSettlementManagement.vue'  // 叠包开包流水
import LeaderLevelManagement from '../components/LeaderLevelManagement.vue'  // 团长等级配置
import InviteReward from '../components/InviteReward.vue'  // 直邀提现奖励
import InviteRewardFlowManagement from '../components/InviteRewardFlowManagement.vue'  // 奖励明细
import WithdrawalOptionManagement from '../components/WithdrawalOptionManagement.vue'  // 提现档位配置
import NewbieLessonManagement from '../components/NewbieLessonManagement.vue'  // 新手课堂
import AdminManagement from '../components/AdminManagement.vue'  // 管理员管理（仅超管）
import AdminLoginLog from '../components/AdminLoginLog.vue'  // 管理员系统日志

// 忽略重复导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Vue.use(Router)

const router = new Router({
  mode: 'history', // 添加这一行以启用history模式
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/data-dashboard',
      name: 'DataDashboard',
      component: DataDashboard
    },
    {
      path: '/main',
      component: MainLayout,
      children: [
        {
          path: '',
          redirect: '/ad-revenue'
        },
        {
          path: '/ad-revenue',
          name: 'AdRevenueQuery',
          component: AdRevenueQuery
        },
        {
          path: '/system/config',
          name: 'SystemConfigManagement',
          component: SystemConfigManagement
        },
        {
          path: '/system/app',
          name: 'AppInfoManagement',
          component: AppInfoManagement
        },
        {
          path: '/newbie-lesson',
          name: 'NewbieLessonManagement',
          component: NewbieLessonManagement,
          meta: {
            title: '新手课堂'
          }
        },
        {
          path: '/user-management',
          name: 'UserManagement',
          component: UserManagement
        },
        {
          path: '/user-withdrawal',
          name: 'UserWithdrawalManagement',
          component: UserWithdrawalManagement
        },
        {
          path: '/withdrawal-option',
          name: 'WithdrawalOptionManagement',
          component: WithdrawalOptionManagement,
          meta: {
            title: '提现档位配置'
          }
        },
        {
          path: '/leader-level',
          name: 'LeaderLevelManagement',
          component: LeaderLevelManagement,
          meta: {
            title: '团长等级配置'
          }
        },
        {
          path: '/invite-reward',
          name: 'InviteReward',
          component: InviteReward,
          meta: {
            title: '直邀提现奖励'
          }
        },
        {
          // 勿用 /admin-*：线上 Nginx 常把 location /admin 代理到后端，会与 API 前缀冲突
          path: '/system/admins',
          name: 'AdminManagement',
          component: AdminManagement,
          meta: {
            title: '管理员管理'
          }
        },
        {
          path: '/system/login-logs',
          name: 'AdminLoginLog',
          component: AdminLoginLog,
          meta: {
            title: '系统日志'
          }
        },
        {
          path: '/risk-management',
          name: 'RiskManagement',
          component: RiskManagement,
          meta: {
            title: '风控管理'
          }
        },
        {
          path: '/coin-flow',
          name: 'CoinFlowManagement',
          component: CoinFlowManagement,
          meta: {
            title: '金币明细'
          }
        },
        {
          path: '/invite-reward-flow',
          name: 'InviteRewardFlowManagement',
          component: InviteRewardFlowManagement,
          meta: {
            title: '奖励明细'
          }
        },
        {
          path: '/ad-pool-settlement',
          name: 'AdPoolSettlementManagement',
          component: AdPoolSettlementManagement,
          meta: {
            title: '叠包开包流水'
          }
        }
      ]
    }
  ]
})

// 全局路由守卫：后台账号（role 0/1）均可登录，权限统一
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const role = parseInt(localStorage.getItem('role'), 10)

  if (to.path === '/login') {
    if (token) {
      next('/ad-revenue')
    } else {
      next()
    }
  } else if (to.path === '/') {
    if (token) {
      next('/ad-revenue')
    } else {
      next('/login')
    }
  } else {
    if (token) {
      if (role !== 0 && role !== 1) {
        localStorage.removeItem('token')
        localStorage.removeItem('role')
        next('/login')
      } else {
        next()
      }
    } else {
      next('/login')
    }
  }
})

export default router